module.exports = __webpack_public_path__ + "img/video_preview.5b8279a2.png";